"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
function formatDate(d) {
    var date = new Date(d);
    var monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December',
    ];
    var day = date.getDate();
    var suffix = day === 1 ? 'st' : day === 2 ? 'nd' : day === 3 ? 'rd' : 'th';
    return "".concat(monthNames[date.getMonth()], " ").concat(day).concat(suffix, ", ").concat(date.getFullYear());
}
function RenderRecentEvents(_a) {
    var events = _a.events, language = _a.language;
    if (!events || events.length === 0) {
        return react_1.default.createElement(Box_1.default, null, "No Recent Events Available");
    }
    var title = language === 'es'
        ? 'Próximos Eventos de Transmisión en Vivo'
        : 'Upcoming Live Streaming Events';
    return (react_1.default.createElement(Box_1.default, null,
        react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h4", sx: {
                textAlign: 'center',
                color: '#FFF',
                fontSize: '28px',
                borderBottom: '2px solid #FFF',
                paddingBottom: '5px',
            } }, title),
        react_1.default.createElement(Box_1.default, { sx: { display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' } }, events.map(function (event, index) { return (react_1.default.createElement(Box_1.default, { key: index, sx: {
                backgroundColor: '#333',
                padding: '10px',
                borderRadius: '5px',
                color: '#FFF',
                flex: '1',
                margin: '5px',
            } },
            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '20px' } }, formatDate(event.start_date)),
            react_1.default.createElement(Box_1.default, { component: "a", href: event.guid, target: "_blank", rel: "noopener noreferrer", sx: {
                    color: '#FFF',
                    fontSize: '15px',
                    lineHeight: '1.1',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                    margin: 0,
                    padding: 0,
                } }, event.post_title))); }))));
}
exports.default = RenderRecentEvents;
